import React from "react";
import ItemReport from "../../components/Report/ItemReport";

const ItemReportPage: React.FC = () => <ItemReport />;
export default ItemReportPage;
